import React from "react";
import styles from "./UpcomingCard.module.css";

interface UpcomingCardProps {
    title: string;
    subtitle: string;
    date: string;
    time?: string;
    locationName?: string;
    firstname?: string;
    lastname?: string;
}

function UpcomingCard({ title, subtitle, date, time, locationName, firstname, lastname }: UpcomingCardProps) {
    const displayTitle = title || "Appointment";
    const displaySubtitle = subtitle || locationName || "";
    const dateTimeText = time ? `${date}, ${time}` : date;
    const displayName = firstname !== undefined && lastname !== undefined ? [firstname, lastname].filter(Boolean).join(' ').trim() : '';
    return (
        <div className={styles.upcomingCard}>
            <h3 className={styles.title}>{displayTitle}</h3>
            {displaySubtitle && displayName ? (
                <p className={styles.subtitle}>{displayName}, {displaySubtitle}</p>
            ) : displaySubtitle ? (
                <p className={styles.subtitle}>{displaySubtitle}</p>
            ) : null}
            <span className={styles.date}>{dateTimeText}</span>
        </div>
    );
}

export default UpcomingCard;